import { AuthResponseSchema, RegisterResponseSchema, OAuthCallbackResponseSchema, OAuthUnlinkResponseSchema, OAuthAccountListResponseSchema, SelectAccountResponseSchema, LogoutResponseSchema, ForgotPasswordResponseSchema, ResetPasswordResponseSchema, ChangePasswordResponseSchema, VerifyEmailResponseSchema, ResendVerificationResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function login(credentials) {
    return api('/auth/login', AuthResponseSchema, {
        method: 'POST',
        body: credentials,
        skipAuth: true,
    });
}
export function register(input) {
    return api('/auth/register', RegisterResponseSchema, {
        method: 'POST',
        body: input,
        skipAuth: true,
    });
}
export function handleOAuthCallback(provider, code, state, attribution) {
    return api(`/auth/oauth/${provider}/callback`, OAuthCallbackResponseSchema, {
        method: 'POST',
        body: { code, state, attribution },
        skipAuth: true,
    });
}
export function selectAccount(accountId) {
    return api('/auth/select-account', SelectAccountResponseSchema, {
        method: 'POST',
        body: { accountId },
    });
}
/**
 * Server-side logout: invalidates the current JWT by bumping the user's tokenVersion.
 * Callers should still clear local token storage afterwards - this just ensures the
 * already-issued token (and every other token for this user) stops working server-side.
 */
export function logout() {
    return api('/auth/logout', LogoutResponseSchema, {
        method: 'POST',
        body: {},
    });
}
export function forgotPassword(input) {
    return api('/auth/forgot-password', ForgotPasswordResponseSchema, {
        method: 'POST',
        body: input,
        skipAuth: true,
    });
}
export function resetPassword(input) {
    return api('/auth/reset-password', ResetPasswordResponseSchema, {
        method: 'POST',
        body: input,
        skipAuth: true,
    });
}
export function changePassword(input) {
    return api('/auth/change-password', ChangePasswordResponseSchema, {
        method: 'POST',
        body: input,
        // A 401 from this endpoint means "wrong current password" (bad input),
        // not "session expired". Keep the token and let the dialog render the
        // error inline instead of triggering the global auto-logout trap.
        skipAuthErrorHandling: true,
    });
}
export function verifyEmail(input) {
    return api('/auth/verify-email', VerifyEmailResponseSchema, {
        method: 'POST',
        body: input,
        skipAuth: true,
    });
}
export function resendVerification(input) {
    return api('/auth/resend-verification', ResendVerificationResponseSchema, {
        method: 'POST',
        body: input,
        skipAuth: true,
    });
}
export function listOAuthAccounts() {
    return api('/auth/oauth/accounts', OAuthAccountListResponseSchema);
}
export function unlinkOAuthAccount(provider) {
    return api(`/auth/oauth/${provider}/unlink`, OAuthUnlinkResponseSchema, {
        method: 'DELETE',
    });
}
export function linkOAuthAccount(provider, code, state) {
    return api(`/auth/oauth/${provider}/link`, OAuthCallbackResponseSchema, {
        method: 'POST',
        body: { code, state },
    });
}
